/*
* @Author: gujianghua
* @Date:   2018-08-04 16:29:58
* @Last Modified by:   gujianghua
* @Last Modified time: 2020-06-18 10:42:16
*/
import { service } from '@/utils/request'
const staticUrl = process.env.BASE_STATIC

export default {
	//推送列表
	getPushList(params) {
	  return service({
	    url: '/cloud/push/admin/pushInfo/pages',
	    method: 'get',
	    params
	  })
	},

	/**
	 * [deletePush 删除内容推送]
	 * @param  {[obj]} params [contentPushId]
	 * @return {[obj]}
	 */
	deletePush(params) {
	  return service({
	    url: '/cloud/push/admin/pushInfo/delete',
	    method: 'post',
	    params
	  })
	},

	/**
	 * [createPush 增加内容推送]
	 * @param  {[obj]} data [表单数据]
	 * @return {[obj]} 
	 */
  	createPush(data) {
	  	return service({
		    url: '/cloud/push/admin/pushInfo/save',
		    method: 'post',
		    data
	  	})
  	},
  	/**
  	 * [getPush 查看数据]
  	 * @param  {[obj]} params [id]
  	 * @return {[obj]} 
  	 */
  	getPush(params) {
	  	return service({
		    url: '/cloud/push/admin/pushInfo/detail',
		    method: 'get',
		    params
	  	})
  	},
  	/**
  	 * [cityExchange 根据code列表获取对应的名称]
  	 * @param  {[obj]} params [ityCode的字符串 英文逗号分隔]
  	 * @return {[obj]} 
  	 */
  	cityExchange(params) {
	  	return service({
		    url: '/cloud/uac/distract/city/list',
		    method: 'post',
		    params: params
	  	})
  	},
  	// 同上
  	departExchange(params) {
	  	return service({
		    url: '/cloud/uac/doctor/departments/list/ids',
		    method: 'post',
		    params: params
	  	})
  	},
  	// 同上
  	jobTitleExchange(params) {
	  	return service({
		    url: '/cloud/uac/doctor/jobTitle/list/ids',
		    method: 'post',
		    params: params
	  	})
  	},
  	// 推送用户列表
  	getUserPages(params) {
	  	return service({
		    url: '/cloud/push/admin/pushInfo/userPages',
		    method: 'get',
		    params
	  	})
  	},
	// 导出数据
	exportAnlysisExcel(params) {
		return service({
			url: '/cloud/push/admin/pushInfo/exportExcel',
			method: 'get',
			params,
			responseType: 'blob'
		})
	},
  	// 下载模板
   down: staticUrl + '/document/sendCoupon.xls',
}


// WEBPACK FOOTER //
// ./src/api/operateManage/contentPush.js